import React from "react";

import {
  DEGRADED,
  OFFLINE,
  OPERATIONAL,
  SCHEDULED_MAINTENANCE,
} from "../../constants/conditions";

export const SlackIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="30 20 220 220"
  >
    <style type="text/css">
      {`.st0{fill:#E01E5A;}
        .st1{fill:#36C5F0;}
        .st2{fill:#2EB67D;}
        .st3{fill:#ECB22E;}
      `}
    </style>
    <g>
      <g>
        <path
          className="st0"
          d="M99.4,151.2c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h12.9V151.2z"
        />
        <path
          className="st0"
          d="M105.9,151.2c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v32.3c0,7.1-5.8,12.9-12.9,12.9
        s-12.9-5.8-12.9-12.9V151.2z"
        />
      </g>
      <g>
        <path
          className="st1"
          d="M118.8,99.4c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v12.9H118.8z"
        />
        <path
          className="st1"
          d="M118.8,105.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9H86.5c-7.1,0-12.9-5.8-12.9-12.9
        s5.8-12.9,12.9-12.9H118.8z"
        />
      </g>
      <g>
        <path
          className="st2"
          d="M170.6,118.8c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9h-12.9V118.8z"
        />
        <path
          className="st2"
          d="M164.1,118.8c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9V86.5c0-7.1,5.8-12.9,12.9-12.9
        c7.1,0,12.9,5.8,12.9,12.9V118.8z"
        />
      </g>
      <g>
        <path
          className="st3"
          d="M151.2,170.6c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9v-12.9H151.2z"
        />
        <path
          className="st3"
          d="M151.2,164.1c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h32.3c7.1,0,12.9,5.8,12.9,12.9
        c0,7.1-5.8,12.9-12.9,12.9H151.2z"
        />
      </g>
    </g>
  </svg>
);

export const RightChevron = ({ className = "" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8295 4.9545C8.26884 4.51517 8.98116 4.51517 9.4205 4.9545L16.1705 11.7045C16.6098 12.1438 16.6098 12.8562 16.1705 13.2955L9.4205 20.0455C8.98116 20.4848 8.26884 20.4848 7.8295 20.0455C7.39017 19.6062 7.39017 18.8938 7.8295 18.4545L13.784 12.5L7.8295 6.5455C7.39017 6.10616 7.39017 5.39384 7.8295 4.9545Z"
      fill="currentColor"
    />
  </svg>
);

export const LeftChevron = ({ className = "" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1705 4.9545C16.6098 5.39384 16.6098 6.10616 16.1705 6.5455L10.216 12.5L16.1705 18.4545C16.6098 18.8938 16.6098 19.6062 16.1705 20.0455C15.7312 20.4848 15.0188 20.4848 14.5795 20.0455L7.8295 13.2955C7.39017 12.8562 7.39017 12.1438 7.8295 11.7045L14.5795 4.9545C15.0188 4.51517 15.7312 4.51517 16.1705 4.9545Z"
      fill="currentColor"
    />
  </svg>
);

export const UpIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4015 9.43279C11.1453 9.68907 10.7297 9.68907 10.4735 9.43279L7 5.95933L3.52654 9.43279C3.27026 9.68907 2.85474 9.68907 2.59846 9.43279C2.34218 9.17651 2.34218 8.76099 2.59846 8.50471L6.53596 4.56721C6.79224 4.31093 7.20776 4.31093 7.46404 4.56721L11.4015 8.50471C11.6578 8.76099 11.6578 9.17651 11.4015 9.43279Z"
      fill="currentColor"
    />
  </svg>
);

export const DownIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.59846 4.56721C2.85474 4.31093 3.27026 4.31093 3.52654 4.56721L7 8.04067L10.4735 4.56721C10.7297 4.31093 11.1453 4.31093 11.4015 4.56721C11.6578 4.82349 11.6578 5.23901 11.4015 5.49529L7.46404 9.43279C7.20776 9.68907 6.79224 9.68907 6.53596 9.43279L2.59846 5.49529C2.34218 5.23901 2.34218 4.82349 2.59846 4.56721Z"
      fill="currentColor"
    />
  </svg>
);

export const TeamIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <rect width="16" height="16" rx="8" fill="#6F6F6F" />
    <path
      d="M8.5399 7.21095C8.8529 6.77345 9.0094 6.28906 9.0094 5.75781C9.0094 5.22656 8.8529 4.74219 8.5399 4.30469C8.8216 4.10156 9.1424 4 9.50235 4C9.9875 4 10.4022 4.17188 10.7465 4.51562C11.0907 4.85938 11.2629 5.27344 11.2629 5.75781C11.2629 6.24219 11.0907 6.65625 10.7465 7C10.4022 7.34375 9.9875 7.5156 9.50235 7.5156C9.1424 7.5156 8.8216 7.41405 8.5399 7.21095ZM4.73709 5.75781C4.73709 5.39844 4.83881 5.07812 5.04225 4.79688C5.24569 4.5 5.50391 4.28125 5.8169 4.14062C6.14554 4 6.48201 3.96875 6.82629 4.04688C7.18625 4.10938 7.4914 4.26562 7.7418 4.51562C7.9922 4.76562 8.14865 5.07031 8.21125 5.42969C8.2895 5.77344 8.2582 6.10938 8.11735 6.4375C7.97655 6.75 7.75745 7.0078 7.4601 7.21095C7.1784 7.41405 6.85759 7.5156 6.49765 7.5156C6.01252 7.5156 5.59781 7.34375 5.25352 7C4.90924 6.65625 4.73709 6.24219 4.73709 5.75781ZM5.74648 5.75781C5.74648 5.96094 5.8169 6.14062 5.95775 6.29688C6.11424 6.4375 6.29421 6.5078 6.49765 6.5078C6.70109 6.5078 6.87324 6.4375 7.0141 6.29688C7.1706 6.14062 7.24885 5.96094 7.24885 5.75781C7.24885 5.55469 7.1706 5.38281 7.0141 5.24219C6.87324 5.08594 6.70109 5.00781 6.49765 5.00781C6.29421 5.00781 6.11424 5.08594 5.95775 5.24219C5.8169 5.38281 5.74648 5.55469 5.74648 5.75781ZM9.9953 10.5156V11.5H3V10.5156L3.02348 10.3047C3.05478 10.1328 3.11737 9.96875 3.21127 9.8125C3.35211 9.5781 3.53208 9.375 3.75118 9.2031C4.03287 9 4.37715 8.83595 4.78404 8.71095C5.26917 8.5703 5.84037 8.5 6.49765 8.5C7.5305 8.5 8.3521 8.6719 8.96245 9.0156C9.40065 9.2656 9.7058 9.59375 9.87795 10C9.9562 10.1875 9.9953 10.3594 9.9953 10.5156ZM9.0094 10.5156C8.96245 10.2656 8.7668 10.0469 8.42255 9.8594C7.9687 9.625 7.32705 9.5078 6.49765 9.5078C5.93427 9.5078 5.44914 9.5703 5.04225 9.6953C4.69796 9.78905 4.43192 9.9219 4.24413 10.0938C4.08763 10.2344 4.00156 10.375 3.98591 10.5156H9.0094ZM9.97185 8.5C10.2848 8.75 10.5274 9.0547 10.6995 9.41405C10.8873 9.7578 10.989 10.125 11.0047 10.5156V11.5H13V10.5156L12.9766 10.3281C12.9453 10.1719 12.8904 10.0156 12.8122 9.8594C12.7027 9.6406 12.5462 9.4531 12.3427 9.2969C12.108 9.0781 11.8106 8.90625 11.4507 8.78125C11.0281 8.6406 10.5352 8.5469 9.97185 8.5Z"
      fill="white"
    />
  </svg>
);

export const TreeFinal = ({ className = "" }) => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0.256 0.799999H1.344V10.656H6.144V11.744H0.256V0.799999Z"
      fill="currentColor"
    />
  </svg>
);

export const TreeMiddle = ({ className = "" }) => (
  <svg
    width="6"
    height="18"
    viewBox="0 0 148 520"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0 0H27.2V246.4H147.2V273.6H27.2V520H0V0Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const ExternalIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <path
      d="M12.4688 5.6875C12.4688 5.86155 12.3996 6.02847 12.2765 6.15154C12.1535 6.27461 11.9865 6.34375 11.8125 6.34375C11.6385 6.34375 11.4715 6.27461 11.3485 6.15154C11.2254 6.02847 11.1562 5.86155 11.1562 5.6875V3.77344L7.9018 7.02789C7.77851 7.15117 7.6113 7.22043 7.43695 7.22043C7.2626 7.22043 7.09539 7.15117 6.97211 7.02789C6.84882 6.90461 6.77956 6.7374 6.77956 6.56305C6.77956 6.3887 6.84882 6.22149 6.97211 6.0982L10.2266 2.84375H8.3125C8.13845 2.84375 7.97153 2.77461 7.84846 2.65154C7.72539 2.52847 7.65625 2.36155 7.65625 2.1875C7.65625 2.01345 7.72539 1.84653 7.84846 1.72346C7.97153 1.60039 8.13845 1.53125 8.3125 1.53125H11.8125C11.9865 1.53125 12.1535 1.60039 12.2765 1.72346C12.3996 1.84653 12.4688 2.01345 12.4688 2.1875V5.6875ZM10.0625 7C9.88845 7 9.72153 7.06914 9.59846 7.19221C9.47539 7.31528 9.40625 7.4822 9.40625 7.65625V11.1562H2.84375V4.59375H6.34375C6.5178 4.59375 6.68472 4.52461 6.80779 4.40154C6.93086 4.27847 7 4.11155 7 3.9375C7 3.76345 6.93086 3.59653 6.80779 3.47346C6.68472 3.35039 6.5178 3.28125 6.34375 3.28125H2.625C2.33492 3.28125 2.05672 3.39648 1.8516 3.6016C1.64648 3.80672 1.53125 4.08492 1.53125 4.375V11.375C1.53125 11.6651 1.64648 11.9433 1.8516 12.1484C2.05672 12.3535 2.33492 12.4688 2.625 12.4688H9.625C9.91508 12.4688 10.1933 12.3535 10.3984 12.1484C10.6035 11.9433 10.7188 11.6651 10.7188 11.375V7.65625C10.7188 7.4822 10.6496 7.31528 10.5265 7.19221C10.4035 7.06914 10.2365 7 10.0625 7Z"
      fill="currentColor"
    />
  </svg>
);

export const LeftArrow = ({ className = "" }) => (
  <div className="text-fh-black dark:text-fh-gray-dark-12">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      className={className}
    >
      <path
        d="M10.6875 6.00002C10.6875 6.1492 10.6282 6.29228 10.5227 6.39777C10.4172 6.50326 10.2741 6.56252 10.125 6.56252H3.23433L5.64933 8.97705C5.755 9.08272 5.81437 9.22604 5.81437 9.37549C5.81437 9.52493 5.755 9.66825 5.64933 9.77392C5.54366 9.8796 5.40034 9.93896 5.25089 9.93896C5.10145 9.93896 4.95813 9.8796 4.85246 9.77392L1.47746 6.39892C1.42502 6.34667 1.38341 6.28457 1.35502 6.2162C1.32663 6.14782 1.31201 6.07452 1.31201 6.00049C1.31201 5.92645 1.32663 5.85315 1.35502 5.78478C1.38341 5.7164 1.42502 5.65431 1.47746 5.60205L4.85246 2.22705C4.90478 2.17473 4.9669 2.13322 5.03526 2.1049C5.10362 2.07659 5.1769 2.06201 5.25089 2.06201C5.32489 2.06201 5.39816 2.07659 5.46653 2.1049C5.53489 2.13322 5.59701 2.17473 5.64933 2.22705C5.70165 2.27937 5.74316 2.34149 5.77148 2.40985C5.79979 2.47822 5.81437 2.55149 5.81437 2.62549C5.81437 2.69948 5.79979 2.77276 5.77148 2.84112C5.74316 2.90948 5.70165 2.9716 5.64933 3.02393L3.23433 5.43752H10.125C10.2741 5.43752 10.4172 5.49678 10.5227 5.60227C10.6282 5.70776 10.6875 5.85083 10.6875 6.00002Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const MaintenanceIcon = ({ className = "" }) => {
  //Not actually maintenance icon, just a placeholder
  return (
    <div className="text-fh-blue-9">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className={className}
      >
        <path
          d="M22.2 17.6335L14.0016 3.39569C13.7967 3.04687 13.5042 2.75764 13.1531 2.55668C12.802 2.35572 12.4045 2.25 12 2.25C11.5955 2.25 11.198 2.35572 10.8469 2.55668C10.4958 2.75764 10.2033 3.04687 9.99844 3.39569L1.8 17.6335C1.60288 17.9709 1.49899 18.3546 1.49899 18.7454C1.49899 19.1361 1.60288 19.5199 1.8 19.8572C2.00225 20.2082 2.29422 20.499 2.64596 20.6998C2.9977 20.9006 3.39655 21.0043 3.80156 21.0001H20.1984C20.6031 21.0039 21.0016 20.9001 21.353 20.6993C21.7044 20.4985 21.996 20.2079 22.1981 19.8572C22.3955 19.52 22.4997 19.1364 22.5001 18.7456C22.5004 18.3549 22.3968 17.9711 22.2 17.6335ZM11.25 9.75006C11.25 9.55115 11.329 9.36038 11.4697 9.21973C11.6103 9.07908 11.8011 9.00006 12 9.00006C12.1989 9.00006 12.3897 9.07908 12.5303 9.21973C12.671 9.36038 12.75 9.55115 12.75 9.75006V13.5001C12.75 13.699 12.671 13.8897 12.5303 14.0304C12.3897 14.171 12.1989 14.2501 12 14.2501C11.8011 14.2501 11.6103 14.171 11.4697 14.0304C11.329 13.8897 11.25 13.699 11.25 13.5001V9.75006ZM12 18.0001C11.7775 18.0001 11.56 17.9341 11.375 17.8105C11.19 17.6868 11.0458 17.5111 10.9606 17.3056C10.8755 17.1 10.8532 16.8738 10.8966 16.6556C10.94 16.4374 11.0472 16.2369 11.2045 16.0796C11.3618 15.9222 11.5623 15.8151 11.7805 15.7717C11.9988 15.7283 12.2249 15.7505 12.4305 15.8357C12.6361 15.9208 12.8118 16.065 12.9354 16.25C13.059 16.435 13.125 16.6526 13.125 16.8751C13.125 17.1734 13.0065 17.4596 12.7955 17.6706C12.5845 17.8815 12.2984 18.0001 12 18.0001Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export const DegradedIcon = ({ className = "" }) => {
  return (
    <div className="rounded-full text-fh-amber-9">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className={className}
      >
        <path
          d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM11.25 7.5C11.25 7.30109 11.329 7.11032 11.4697 6.96967C11.6103 6.82902 11.8011 6.75 12 6.75C12.1989 6.75 12.3897 6.82902 12.5303 6.96967C12.671 7.11032 12.75 7.30109 12.75 7.5V12.75C12.75 12.9489 12.671 13.1397 12.5303 13.2803C12.3897 13.421 12.1989 13.5 12 13.5C11.8011 13.5 11.6103 13.421 11.4697 13.2803C11.329 13.1397 11.25 12.9489 11.25 12.75V7.5ZM12 17.25C11.7775 17.25 11.56 17.184 11.375 17.0604C11.19 16.9368 11.0458 16.7611 10.9606 16.5555C10.8755 16.35 10.8532 16.1238 10.8966 15.9055C10.94 15.6873 11.0472 15.4868 11.2045 15.3295C11.3618 15.1722 11.5623 15.065 11.7805 15.0216C11.9988 14.9782 12.225 15.0005 12.4305 15.0856C12.6361 15.1708 12.8118 15.315 12.9354 15.5C13.059 15.685 13.125 15.9025 13.125 16.125C13.125 16.4234 13.0065 16.7095 12.7955 16.9205C12.5845 17.1315 12.2984 17.25 12 17.25Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export const OutageIcon = ({ className = "" }) => {
  return (
    <div className="text-fh-tomato-9">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className={className}
      >
        <path
          d="M22.2 17.6335L14.0016 3.39569C13.7967 3.04687 13.5042 2.75764 13.1531 2.55668C12.802 2.35572 12.4045 2.25 12 2.25C11.5955 2.25 11.198 2.35572 10.8469 2.55668C10.4958 2.75764 10.2033 3.04687 9.99844 3.39569L1.8 17.6335C1.60288 17.9709 1.49899 18.3546 1.49899 18.7454C1.49899 19.1361 1.60288 19.5199 1.8 19.8572C2.00225 20.2082 2.29422 20.499 2.64596 20.6998C2.9977 20.9006 3.39655 21.0043 3.80156 21.0001H20.1984C20.6031 21.0039 21.0016 20.9001 21.353 20.6993C21.7044 20.4985 21.996 20.2079 22.1981 19.8572C22.3955 19.52 22.4997 19.1364 22.5001 18.7456C22.5004 18.3549 22.3968 17.9711 22.2 17.6335ZM11.25 9.75006C11.25 9.55115 11.329 9.36038 11.4697 9.21973C11.6103 9.07908 11.8011 9.00006 12 9.00006C12.1989 9.00006 12.3897 9.07908 12.5303 9.21973C12.671 9.36038 12.75 9.55115 12.75 9.75006V13.5001C12.75 13.699 12.671 13.8897 12.5303 14.0304C12.3897 14.171 12.1989 14.2501 12 14.2501C11.8011 14.2501 11.6103 14.171 11.4697 14.0304C11.329 13.8897 11.25 13.699 11.25 13.5001V9.75006ZM12 18.0001C11.7775 18.0001 11.56 17.9341 11.375 17.8105C11.19 17.6868 11.0458 17.5111 10.9606 17.3056C10.8755 17.1 10.8532 16.8738 10.8966 16.6556C10.94 16.4374 11.0472 16.2369 11.2045 16.0796C11.3618 15.9222 11.5623 15.8151 11.7805 15.7717C11.9988 15.7283 12.2249 15.7505 12.4305 15.8357C12.6361 15.9208 12.8118 16.065 12.9354 16.25C13.059 16.435 13.125 16.6526 13.125 16.8751C13.125 17.1734 13.0065 17.4596 12.7955 17.6706C12.5845 17.8815 12.2984 18.0001 12 18.0001Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export const OperationalIcon = ({ className = "" }) => {
  return (
    <div className="rounded-full text-fh-green-9">
      <svg
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M16.5 3.5C13.9288 3.5 11.4154 4.26244 9.27759 5.6909C7.13975 7.11935 5.47351 9.14968 4.48957 11.5251C3.50563 13.9006 3.24819 16.5144 3.7498 19.0362C4.25141 21.5579 5.48953 23.8743 7.30762 25.6924C9.1257 27.5105 11.4421 28.7486 13.9638 29.2502C16.4856 29.7518 19.0995 29.4944 21.4749 28.5104C23.8503 27.5265 25.8807 25.8603 27.3091 23.7224C28.7376 21.5846 29.5 19.0712 29.5 16.5C29.4964 13.0533 28.1256 9.74882 25.6884 7.31163C23.2512 4.87445 19.9467 3.50364 16.5 3.5ZM22.2075 14.2075L15.2075 21.2075C15.1146 21.3005 15.0043 21.3742 14.8829 21.4246C14.7615 21.4749 14.6314 21.5008 14.5 21.5008C14.3686 21.5008 14.2385 21.4749 14.1171 21.4246C13.9957 21.3742 13.8854 21.3005 13.7925 21.2075L10.7925 18.2075C10.6049 18.0199 10.4994 17.7654 10.4994 17.5C10.4994 17.2346 10.6049 16.9801 10.7925 16.7925C10.9801 16.6049 11.2346 16.4994 11.5 16.4994C11.7654 16.4994 12.0199 16.6049 12.2075 16.7925L14.5 19.0863L20.7925 12.7925C20.8854 12.6996 20.9957 12.6259 21.1171 12.5756C21.2385 12.5253 21.3686 12.4994 21.5 12.4994C21.6314 12.4994 21.7615 12.5253 21.8829 12.5756C22.0043 12.6259 22.1146 12.6996 22.2075 12.7925C22.3004 12.8854 22.3741 12.9957 22.4244 13.1171C22.4747 13.2385 22.5006 13.3686 22.5006 13.5C22.5006 13.6314 22.4747 13.7615 22.4244 13.8829C22.3741 14.0043 22.3004 14.1146 22.2075 14.2075Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export const StatusIcons = {
  [DEGRADED]: DegradedIcon,
  [OPERATIONAL]: OperationalIcon,
  [OFFLINE]: OutageIcon,
  [SCHEDULED_MAINTENANCE]: MaintenanceIcon,
};
